var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"iframeContainer",staticClass:"h-full"},[_c('iframe',{staticClass:"w-full",staticStyle:{"overflow-y":"hidden"},style:({ height: _vm.iframeHeight }),attrs:{"frameborder":"0","src":"https://hrc.groovepages.com/gpiframes/groovecopypro"},on:{"load":_vm.load}})])
}
var staticRenderFns = []

export { render, staticRenderFns }